"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_70_3_0 = void 0;
/**
 * Migrate to 70.3.0
 *
 * delete Bom on Config
 * delete Cablepool on Config
 *
 */
const migration_70_3_0 = (json) => {
    delete json.Bom;
    delete json.Cablepool;
    return json;
};
exports.migration_70_3_0 = migration_70_3_0;
//# sourceMappingURL=migration_70_3_0.js.map